<template>

    <div></div>

</template>

<script>

import Vuex from 'vuex'

export default {

    name: 'check-offline',

    computed: {

        ...Vuex.mapGetters(['internet'])

    },

    mounted() {

        this.$on('online', () => {
            this.setInternetStatus(true)
            this.$router.go(0)
        })

        this.$on('offline', () => {
            this.setInternetStatus(false)
        })
    },

    methods: {

        ...Vuex.mapActions([
            'setInternetStatus'
        ])

    }

}
</script>
